<template>
    <div id="main-grid" class="grid simple main borderRadius12px" style="background: #e5e9ec">
      <div class="well form-group" style="background: #e5e9ec">
  
        <!--title -->
        <div class="grid-title no-border borderTop">
          <h4 style="padding-left: 6px"> {{ i18nValues["fieldSiteEdition"] }} </h4>
        </div>        
  
        <!-- body -->
        <div class="grid-body no-border borderBottom">
          <el-form v-loading="loading != 0" :model="fieldSiteToSave" ref="formFieldSite" :rules="rules">
            <div class="gridTemplate">
  
                <!-- Name -->    
                <el-form-item :label="i18nValues['fieldSite']" prop="name"> 
                  <el-input v-model="fieldSiteToSave.name" maxlength="30" :placeholder="i18nValues['name']"></el-input>
                </el-form-item>     
                
                <!-- Batch Prefix -->    
                <el-form-item :label="i18nValues['batchPrefix']" prop="batchPrefix"> 
                  <el-input v-model="fieldSiteToSave.batchPrefix" maxlength="30"></el-input>
                </el-form-item> 

                <!-- Users --> 
                <el-form-item :label="i18nValues['users']" prop="users">
                  <el-select 
                    v-model="fieldSiteToSave.userIds" 
                    :placeholder="i18nValues['users']"
                    multiple
                  >
                    <el-option
                      v-for="item in UsersList"
                      :key="item.userId" 
                      :label="item.name"
                      :value="item.userId"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
  
            </div>          
          </el-form>
  
          <!-- CANCEL/SAVE --> 
          <div class="full-width d-flex justify-content-end mt-2">
            <el-button :loading="loading" size="small" @click="cancel()">
              {{ i18nValues["cancel"] }}
            </el-button>
            <el-button v-if="!isReadOnly()" icon="fas fa-check" :loading="loading" size="small" class="btn-primary" @click="save()">
              {{ i18nValues["save"] }}
            </el-button>
          </div>  
  
        </div>      
      </div>
    </div>
  </template>
  
  <script>
  import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
  export default {
    name: "FieldSiteEdition",  
  
    created(){
      this.retrieveUsers();

      if(parseInt(this.id) !== 0 ){
          this.retrieveById();
      } else {
        this.fieldSite.creationUser = this.user.name;
        this.fieldSite.creationDate = new Date();
      }
  
      this.rules= {
        name:[{required: true, message: this.i18nValues["requiredValue"], trigger: 'blur' }],
      };

    // Capture initial query to preserve filters/pagination when returning
    this.returnQuery = { ...this.$route.query };
  
    },
  
    components: {},

    computed: {
      loading: get("fieldSite/loading"),
    },
  
    props:["id"],
  
    data() {
      return {
  
        fieldSite: {},

        fieldSiteToSave: {},

        UsersList: [],

        rules:{},
        returnQuery: {},
  
      };
    },
  
    methods: {
      retrieveUsers() {
        this.$store.dispatch("user/retrieveUsers").then((res) => {
          this.UsersList = res;
          console.log("Users: ", this.UsersList);//eslint-disable-line
        });
      },

      // retrieveUsers() {
      //   this.$store.dispatch("user/retrieveUsers").then((res) => {
      //     const uniqueUsers = [];
      //     const seenUserIds = new Set();

      //     res.forEach((user) => {
      //     if (seenUserIds.has(user.userId)) {
      //       console.log(`Duplicado encontrado: ${user.userId}`); //eslint-disable-line
      //     } else {
      //       seenUserIds.add(user.userId);
      //       uniqueUsers.push(user);
      //     }
      //   });

      //     this.UsersList = uniqueUsers;
   
      //     console.log("Unique Users: ", this.UsersList); //eslint-disable-line
      //   });
      // },

      save(){
        this.fieldSiteToSave.users = this.fieldSiteToSave.userIds.map(id => {
          const user = this.UsersList.find(user => user.userId === id);
          return { userId: user.userId, name: user.name };
        });

        //console.log("Planta a guardar: ", this.fieldSite);//eslint-disable-line

        this.$refs["formFieldSite"].validate(valid => {
          if(valid){
            this.$store.dispatch("fieldSite/saveFieldSite", this.fieldSiteToSave).then((res) =>{            
              if(res.status == "OK"){
                  this.$notify.success({
                      title: this.i18nValues["succes"],
                      message: this.i18nValues["fieldSiteSaved"],
                      position: "bottom-right",
                  }); 
              this.$root.$refs.App.retrieveFieldSites();    
                  this.$router.push({name:"FieldSiteAdmin", query: this.returnQuery});
              } else {
                  this.$notify.error({
                      title: this.i18nValues["error"],
                      message: this.i18nValues["fieldSiteSavedError"],
                      position: "bottom-right",
                  });
              }           
            });
          }
        });
      },
  
      cancel(){
          this.$router.push({name:"FieldSiteAdmin", query: this.returnQuery});
      },
  
      retrieveById(){
          this.$store.dispatch("fieldSite/retrieveFieldSiteById", this.id ).then((res)=>{
              this.fieldSite = res;
              this.fieldSite.modificationUser = this.user.name;
              this.fieldSite.modificationDate = new Date();

              this.setUserIds();

              this.fieldSiteToSave = {...this.fieldSite};

              console.log("Planta: ", this.fieldSite);//eslint-disable-line

          });       
      },

      setUserIds() {
        this.fieldSite.userIds = this.fieldSite.users.map(user => user.userId);
      }
      
    },
  
  
  }
  </script>
  
  <style>
  
  </style>
  